import { type SVGProps } from 'react';

interface CoffeeIconProps extends SVGProps<SVGSVGElement> {
    size?: 'small' | 'medium';
}

export const CoffeeIcon = ({ size = 'medium', ...props }: CoffeeIconProps): JSX.Element => {
    const dimension = size === 'small' ? 20 : 24;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            width={dimension}
            height={dimension}
            {...props}
        >
            <path d="M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2m0 5h-2V5h2zM4 19h16v2H4z" />
        </svg>
    );
};